export enum SpotInvokeEnum {
  SUBSCRIBE = 'trading-pair-price-sub',
  UNSUBSCRIBE = 'trading-pair-price-unsub',
  RECEIVE_BESTBID = 'trading-pair-price-receive-bestbid',
  RECEIVE_BESTASK = 'trading-pair-price-receive-bestask',
  RECEIVE_LASTPRICE = 'trading-pair-price-receive-lastprice',
  ORDER_CLOSED = 'order-closed',
  ORDER_UPDATED = 'order-updated',
  ORDER_OPENED = 'order-opened',
}

export type SpotSocketConfigType = {
  invokeType: SpotInvokeEnum;
  data: [string[], string];
  symbol?: string;
  hub: string;
  subscribeId: string;
  id: string;
  ref?: string;
  hubEvents?: SpotInvokeEnum[];
};
